module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-conversation-selected-678cede84c29e7d9757349e079225dad.png";